import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShieldAlert } from 'lucide-react';

const Unauthorized = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4">
      <ShieldAlert className="h-16 w-16 text-yellow-500 mb-6" />
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        {t('unauthorized')}
      </h1>
      <p className="text-gray-600 dark:text-gray-400 max-w-md mb-8">
        {t('unauthorizedMessage')}
      </p>
      <div className="flex space-x-4">
        <button
          onClick={() => navigate('/')}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          {t('backToDashboard')}
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;
